<template>
    <el-dialog custom-class="collection_dialog" :model-value="show" title="定期登录验证" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content" v-loading="loading">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-shoucang1"></i></div>
            <h1>添加收藏</h1>
            <h2>请选择收藏夹</h2>
            <div class="search_input">
                <i class="iconfont icon-sousuo"></i>
                <input type="text" placeholder="搜索收藏夹" v-model.trim="keyword" />
            </div>
            <ul class="list scrollbar">
                <li class="list_item" v-for="item in listC" :key="item.id">
                    <span class="name">{{ item.favoriteName }}</span>
                    <span class="num">({{ item.total }})</span>
                    <div class="btn" @click="onColl(item)">收藏</div>
                </li>
                <li v-if="!listC.length"><p class="no">暂无收藏夹</p></li>
            </ul>
            <div class="new_box">
                <div class="btn" v-if="!creating" @click="creating = true">
                    <i class="iconfont icon-xinzeng"></i>
                    <span>新建收藏夹</span>
                </div>
                <div class="new_input" v-else>
                    <input type="text" placeholder="请输入收藏夹名称" maxlength="6" v-model.trim="favoriteName" />
                    <div class="btn" @click="closeCreate">取消</div>
                    <div class="btn submit" @click="createCollection">确定</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { Close } from "@element-plus/icons-vue";
import { apiFavoriteAll, apiFavoriteArticleAdd } from "@/request/api";
import { cloneDeep } from "loadsh";
import { ElMessage } from "element-plus";
import useCreateColl from "./useCreateColl";

const props = defineProps({
    show: { type: Boolean, default: false },
    art: { type: Object, default: {} },
});
const emits = defineEmits(["close", "success"]);
const keyword = ref("");
const list = ref([]);
const listC = computed(() => {
    const res = cloneDeep(list.value);
    // 根据关键字过滤
    if (keyword.value) {
        return res.filter((item) => {
            return item.favoriteName.includes(keyword.value);
        });
    }
    return res;
});
const loading = ref(false);

// 获取收藏夹列表
async function getFavoriteList() {
    const { data } = await apiFavoriteAll();
    list.value = data || [];
}

// 点击收藏
async function onColl(row) {
    loading.value = true;
    try {
        const params = {
            articleId: props.art.articleId,
            weeklyId: props.art.weeklyId,
            tagId: props.art.tagId,
            id: row.id,
        };
        const { code } = await apiFavoriteArticleAdd(params);
        if (code !== "0") return;
        ElMessage.success("收藏成功");
        handleClose();
        emits("success", row.id);
    } finally {
        loading.value = false;
    }
}

// 新建收藏夹
const { creating, closeCreate, favoriteName, createCollection } = useCreateColl({ getFavoriteList });

// 打开
function handleOpen() {
    getFavoriteList();
}

// 关闭
function handleClose() {
    emits("close");
}
</script>

<style lang="scss">
.collection_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        padding-bottom: 0;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .search_input {
            height: 48px;
            border-radius: 24px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            padding-left: 21px;
            margin-top: 16px;
            .iconfont {
                font-size: 26px;
                color: #979797;
            }
            input {
                height: 100%;
                line-height: 48px;
                background: none;
                flex: 1;
                padding: 0 20px;
                border: none;
                font-size: 18px;
            }
        }
        .list {
            margin-top: 16px;
            width: 100%;
            height: 240px;
            overflow-y: auto;
            border-bottom: 1px solid #d8d8d8;
            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                width: 100%;
                height: 48px;
                border-radius: 8px;
                padding-left: 16px;
                padding-right: 10px;
                transition: all 0.3s;
                p.no {
                    text-align: center;
                    display: block;
                    width: 100%;
                }
                .name {
                    font-size: 14px;
                    color: #2a2a2a;
                }
                .num {
                    font-size: 14px;
                    color: #727272;
                }
                .btn {
                    position: absolute;
                    height: 44px;
                    width: 64px;
                    background-color: var(--primary-color);
                    color: #fff;
                    text-align: center;
                    line-height: 44px;
                    border-radius: 8px;
                    top: 2px;
                    right: 2px;
                    cursor: pointer;
                    display: none;
                }
                &.list_item:hover {
                    background-color: #ffeee4;
                    .btn {
                        display: block;
                    }
                }
            }
        }
        .new_box {
            height: 56px;
            display: flex;
            align-items: center;
            .btn {
                width: 100%;
                height: inherit;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;
                .iconfont {
                    color: var(--primary-color);
                    font-size: 20px;
                }
                span {
                    font-size: 18px;
                    padding-left: 8px;
                    user-select: none;
                }
            }
            .new_input {
                height: 40px;
                width: 100%;
                border: 1px solid #ff5a00;
                border-radius: 8px;
                display: flex;
                align-items: center;
                padding-right: 4px;
                padding-left: 8px;
                input {
                    flex: 1;
                    height: 100%;
                    background: none;
                    border: none;
                }
                .btn {
                    width: 64px;
                    height: 32px;
                    background-color: #f0f0f0;
                    border-radius: 8px;
                    margin-left: 8px;
                    display: flex;
                    justify-content: center;
                    color: #2a2a2a;
                    font-size: 14px;
                    &.submit {
                        background-color: var(--primary-color);
                        color: #fff;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
}
</style>
